import { Link } from 'react-router-dom'

/**
 * @param {{ items: Array<{ href: string, label?: string, labelKey?: string, openInNewTab?: boolean }>, getLabel: (item: object) => string, onNavigate?: () => void }} props
 */
function NavMenuLinks({ items, getLabel, onNavigate }) {
  return items.map((item) => {
    const { href, labelKey, label, openInNewTab } = item
    const text = getLabel({ labelKey, label })
    const key = `${href}-${label || labelKey || ''}`
    const isInternal = href?.startsWith('/') && !href.startsWith('//')

    if (isInternal) {
      return (
        <Link key={key} to={href} onClick={onNavigate}>
          {text}
        </Link>
      )
    }

    return (
      <a
        key={key}
        href={href}
        onClick={onNavigate}
        target={openInNewTab ? '_blank' : undefined}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
      >
        {text}
      </a>
    )
  })
}

export default NavMenuLinks
